import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';

@Component({
  selector: 'irembogov-formly-switch',
  templateUrl: './formly-switch.component.html',
  styleUrls: ['./formly-switch.component.scss'],
})
export class FormlySwitchComponent extends FieldType<FieldTypeConfig> {}
